import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CircleSlash } from 'lucide-react';
import { Button } from '@/shared/ui/buttons/Button';
import { useCurrentUser } from '@/entities/auth';
import { firstAccessiblePath } from '@/app/router/ProtectedRoute';

/**
 * Inside-shell "no access" content. The surrounding `AdminShellWrapper` still
 * renders the topbar (with logout) and the permission-filtered sidebar, so the
 * user is never stranded — they can switch sections or sign out from here.
 *
 * The CTA points to `firstAccessiblePath(permissions)`: if the user has any
 * accessible section it sends them there, otherwise it stays on `/no-access`.
 */
export const WidgetsNoAccessMain = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { permissions } = useCurrentUser();
  const target = firstAccessiblePath(permissions);
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <CircleSlash className="h-12 w-12 text-ink-faint" aria-hidden />
        <h1 className="text-xl font-semibold text-ink">{t('notFound.title')}</h1>
        <p className="text-sm text-ink-muted">{t('notFound.description')}</p>
        <Button onClick={() => navigate(target)} className="mt-3">
          {t('notFound.goHome')}
        </Button>
      </div>
    </div>
  );
};
